import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-212c8340"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseCheckbox = _resolveComponent("BaseCheckbox")!
  const _component_BaseAlert = _resolveComponent("BaseAlert")!

  return (_ctx.content)
    ? (_openBlock(), _createBlock(_component_BaseAlert, {
        key: 0,
        title: _ctx.content?.title,
        type: "info"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "alert__content",
            innerHTML: _ctx.content.body
          }, null, 8, _hoisted_1),
          _createVNode(_component_BaseCheckbox, {
            id: `${_ctx.TermTypeEnum.PetCrate}`,
            label: "Please tick to confirm you have read and understood the above statement",
            isHtml: true,
            disabled: false,
            modelValue: _ctx.inputValue,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event))
          }, null, 8, ["id", "modelValue"])
        ]),
        _: 1
      }, 8, ["title"]))
    : _createCommentVNode("", true)
}